import React from "react";
import { LABELS } from "@/common/constants/constants";
import JobCard from "@/common/components/cards/job-card/JobCard";
import { v4 as uuidv4 } from "uuid";
import { IJobCardNew } from "@/common/types/Types";
import { gtmPushDataLayer } from "@/common/utils/utils";
import Link from "next/link";

import styles from "./JobsListCardsSection.module.scss";

interface IProps {
  jobsData: IJobCardNew[];
  customTitle: string;
  gtmKeyword: string;
}

const JobsListCardsSection = ({
  jobsData,
  customTitle,
  gtmKeyword,
}: IProps) => {
  const handleClickDataLayer = (jobCard: IJobCardNew) => {
    const url = new URL(jobCard.url);
    const country = url.hostname.split(".")[0];
    const advertiser = url.hostname.split(".")[1];

    gtmPushDataLayer({
      event: "clickOut",
      keyword: gtmKeyword,
      advertiser,
      title: jobCard.title,
      country,
      page: "JobsList",
      url: jobCard.url,
    });
  };

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{customTitle}</h1>
      <div className={styles.cards}>
        {(jobsData || [])?.map((item) => {
          return (
            <Link
              key={uuidv4()}
              href={item.url}
              target="_blank"
              onClick={() => handleClickDataLayer(item)}
            >
              <JobCard
                title={item.title}
                snippet={item.snippet ? item.snippet : item.description}
                company={item.company ? item.company : item.employer}
                location={
                  typeof item.location === "string"
                    ? item.location
                    : item.location?.location[0]
                }
                logo={item.logo}
                url={item.url}
              />
            </Link>
          );
        })}
        {/* <button className={styles.showMoreBtn}>{BUTTON_LABEL.SHOW_MORE}</button> */}
      </div>
    </div>
  );
};

export default JobsListCardsSection;
